module.exports = __webpack_public_path__ + "img/cl_user_avatar.d48114da.png";